import React from "react";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useLang } from "../i18n/LanguageContext";
import SEO from "../components/SEO";

const News = () => {
  const { t } = useLang();

  const covers = [
    "https://images.pexels.com/photos/11703173/pexels-photo-11703173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/2101140/pexels-photo-2101140.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1777304610456-e9d6206b19a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxjaGVtaWNhbCUyMGRydW1zfGVufDB8fHx8MTc4MDY4OTI5OXww&ixlib=rb-4.1.0&q=85",
  ];

  return (
    <>
      <SEO
        title="News & Insights"
        description="Updates, technical notes and announcements from Masika Chem SARL — mining reagents and industrial chemistry from the DRC's Copperbelt."
        path="/news"
      />

      <section className="bg-white border-b border-neutral-200" data-testid="news-hero">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="inline-flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-[#C8102E]" />
              <span className="text-[11px] font-bold tracking-[0.3em] uppercase text-[#C8102E]">
                {t.news.overline}
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-neutral-900">
              {t.news.title}
            </h1>
          </div>
          <div className="md:col-span-5 flex items-end">
            <p className="text-lg text-neutral-600 leading-relaxed">{t.news.sub}</p>
          </div>
        </div>
      </section>

      <section className="bg-[#F7F7F5] py-24" data-testid="news-list">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-8">
          {t.news.items.map((n, i) => (
            <article
              key={i}
              data-testid={`news-item-${i}`}
              className="group bg-white border border-neutral-200 hover:border-[#C8102E] transition-colors flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={covers[i % covers.length]}
                  alt={n.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7 flex-1 flex flex-col">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-[10px] font-bold tracking-[0.25em] uppercase text-[#C8102E]">
                    {n.tag}
                  </span>
                  <span className="text-xs text-neutral-500">{n.date}</span>
                </div>
                <h3 className="text-xl font-bold text-neutral-900 leading-snug tracking-tight">
                  {n.title}
                </h3>
                <p className="mt-3 text-sm text-neutral-600 leading-relaxed flex-1">{n.excerpt}</p>
                <button
                  data-testid={`news-read-${i}`}
                  className="mt-6 inline-flex items-center gap-1 text-xs font-bold text-[#171717] group-hover:text-[#C8102E]"
                >
                  {t.common.readMore} <ArrowUpRight size={14} weight="bold" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
};

export default News;
